import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tool-footer level is-mobile" }

import ChannelIdentityPicker from '@/features/bots/components/botTestTool/ChannelIdentityPicker.vue';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import RestartIcon from 'vue-material-design-icons/Restart.vue';
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationControlBar',
  emits: ["channelChanged", "resetClicked"],
  setup(__props, { emit: __emit }) {

const channelIdentity = ref<ChannelIdentityViewModel>({
  id: 'web-assistant-default',
  type: 'web-assistant',
  name: 'Web Assistant',
  externalId: '',
});

const emit = __emit;

watch(channelIdentity, (identity) => emit('channelChanged', identity.type, identity.id), { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "tool-footer__span level-item is-narrow" }, "Previewing: ", -1)),
    _createVNode(ChannelIdentityPicker, {
      modelValue: channelIdentity.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((channelIdentity).value = $event)),
      class: "tool-footer__channel is-flex-grow-1 level-item"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_n_button, {
      variant: "danger",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('resetClicked'))),
      class: "reset-button level-item is-narrow"
    }, {
      default: _withCtx(() => [
        _createVNode(RestartIcon, { class: "restart-icon icon-1-3x" }),
        _cache[2] || (_cache[2] = _createTextVNode(" Restart ", -1))
      ]),
      _: 1
    })
  ]))
}
}

})